// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.element-property-item > .nkl-form-item-label > label {
  display: flex;
  width: 100%;
}
.nkl-form-vertical.branding-element label {
  display: flex;
  width: 100%;
}
.nkl-form-vertical.branding-element label .fallback-tag-container {
  margin-left: auto;
}
.nkl-form-vertical.branding-element label .fallback-tag {
  margin: 0;
}
.preview-container {
  background: #0000001a;
  display: flex;
  align-items: center;
  justify-items: center;
  height: 100%;
  padding: 24px;
  margin: 0 0 0 48px;
  border-radius: 4px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
